// src/pages/hr/HREmployeeServices.jsx
import React from "react";
import Layout from "../../components/common/Layout";
import EmployeeServicesModule from "./EmployeeServicesModule";

export default function HREmployeeServices() {
  return (
    <Layout>
      <EmployeeServicesModule />
    </Layout>
  );
}
